import { render, staticRenderFns } from "./SystemChatInfo.vue?vue&type=template&id=083da940&scoped=true&lang=pug"
import script from "./SystemChatInfo.vue?vue&type=script&lang=js"
export * from "./SystemChatInfo.vue?vue&type=script&lang=js"
import style0 from "./SystemChatInfo.vue?vue&type=style&index=0&id=083da940&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083da940",
  null
  
)

export default component.exports